import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "react-loading-skeleton/dist/skeleton.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import "react-quill-new/dist/quill.snow.css";
import "./index.css";
// import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "react-dropzone-uploader/dist/styles.css";
import "animate.css";
import "moment/locale/fr";
import "react-phone-input-2/lib/style.css";
import { Provider } from "react-redux";
import store from "./redux/store";
import { fr } from "yup-locales";
import * as Sentry from "@sentry/react";
import { setLocale } from "yup";
import SplashScreen from "./shared/SplashScreen";
const App = lazy(() => import('./App'));

setLocale(fr);
if (process.env.NODE_ENV !== "development") {

  Sentry.init({
    dsn: "https://917cf9bb242fd872b3264acb97496d9d@o4509598342578176.ingest.de.sentry.io/4509763000402000",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 1.0
  });
}
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Suspense fallback={<SplashScreen />}>
        <App />
      </Suspense>
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
